import styled from 'styled-components';

export const ContentTable = styled.div`
  @media (max-width: 768px) {
    border: 1px solid #ebebec;
    border-radius: 12px;
    .content-header {
      background: #f8fbff;
      padding: 16px;
    }
    ul {
      li {
        padding: 16px;
        border-bottom: 1px solid #ebebec;
      }
    }
  }
`;
